
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var cards   = document.querySelector('.js-top-thanks-cards');
    var prevBtn = document.querySelector('.js-top-thanks-prev');
    var nextBtn = document.querySelector('.js-top-thanks-next');
    var line    = document.querySelector('.js-top-thanks-line');
    var thumb   = document.querySelector('.js-top-thanks-thumb');

    if (!cards) return;

    function getStep() {
      var card = cards.querySelector('.js-top-thanks-card');
      if (!card) return 0;
      var cardRect    = card.getBoundingClientRect();
      var nextSibling = card.nextElementSibling;
      var gap         = 0;

      if (nextSibling) {
        var nextRect = nextSibling.getBoundingClientRect();
        gap = Math.max(0, nextRect.left - cardRect.right);
      }
      return cardRect.width + gap;
    }

    function getScrollable() {
      return cards.scrollWidth - cards.clientWidth;
    }

    
    function getMaxIndex() {
      var step = getStep();
      if (!step) return 0;
      return Math.floor((getScrollable() + step * 0.1) / step);
    }

    function getCurrentIndex() {
      var step = getStep();
      if (!step) return 0;
      return Math.round(cards.scrollLeft / step);
    }

    function updateBtnState() {
      if (!prevBtn || !nextBtn) return;
      var step = getStep();
      var scrollable = getScrollable();
      if (!step || scrollable <= 0) {
        prevBtn.disabled = true;
        nextBtn.disabled = true;
        return;
      }
      
      prevBtn.disabled = (cards.scrollLeft <= 1);
      nextBtn.disabled = (cards.scrollLeft >= scrollable - 1);
    }

    function updateThumb() {
      if (!line || !thumb) return;
      var scrollable = getScrollable();
      if (scrollable <= 0) {
        thumb.classList.add('is-hidden');
        return;
      }
      thumb.classList.remove('is-hidden');

      var trackWidth = line.clientWidth;
      var ratio      = cards.clientWidth / cards.scrollWidth;
      
      var thumbWidth = Math.max(30, trackWidth * ratio);
      var maxThumbLeft = trackWidth - thumbWidth;
      var progress   = cards.scrollLeft / scrollable;
      var thumbLeft  = maxThumbLeft * progress;

      thumb.style.width = thumbWidth + 'px';
      thumb.style.transform = 'translate(' + thumbLeft + 'px, -50%)';
    }

    
    function scrollByCard(direction) {
      var step = getStep();
      if (!step) return;
      var scrollable  = getScrollable();
      var maxIndex    = getMaxIndex();
      var newIndex    = getCurrentIndex() + direction;
      var target;

      if (direction > 0 && newIndex >= maxIndex) {
        target = scrollable;
      } else if (direction < 0 && newIndex <= 0) {
        target = 0;
      } else {
        target = newIndex * step;
      }

      cards.scrollTo({ left: target, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });

    cards.addEventListener('scroll', function () {
      updateBtnState();
      updateThumb();
    }, { passive: true });
    window.addEventListener('resize', function () {
      updateBtnState();
      updateThumb();
    });

    
    if (thumb) {
      var dragging = false;
      var startX = 0;
      var startScroll = 0;

      thumb.addEventListener('pointerdown', function (e) {
        dragging = true;
        startX = e.clientX;
        startScroll = cards.scrollLeft;
        try { thumb.setPointerCapture(e.pointerId); } catch (err) {}
        e.preventDefault();
      });

      thumb.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        var trackWidth = line.clientWidth;
        var thumbWidth = thumb.offsetWidth;
        var maxThumbLeft = trackWidth - thumbWidth;
        if (maxThumbLeft <= 0) return;
        var scrollable = getScrollable();
        var deltaScroll = (dx / maxThumbLeft) * scrollable;
        cards.scrollLeft = startScroll + deltaScroll;
      });

      function endDrag(e) {
        if (!dragging) return;
        dragging = false;
        try { thumb.releasePointerCapture(e.pointerId); } catch (err) {}
      }
      thumb.addEventListener('pointerup', endDrag);
      thumb.addEventListener('pointercancel', endDrag);
    }

    
    if (line) {
      line.addEventListener('click', function (e) {
        if (thumb && (e.target === thumb || thumb.contains(e.target))) return;
        var rect       = line.getBoundingClientRect();
        var clickX     = e.clientX - rect.left;
        var trackWidth = line.clientWidth;
        var thumbWidth = thumb ? thumb.offsetWidth : 30;
        var maxThumbLeft = trackWidth - thumbWidth;
        if (maxThumbLeft <= 0) return;
        var targetLeft = Math.max(0, Math.min(maxThumbLeft, clickX - thumbWidth / 2));
        var scrollable = getScrollable();
        cards.scrollTo({
          left: (targetLeft / maxThumbLeft) * scrollable,
          behavior: 'smooth'
        });
      });
    }

    updateBtnState();
    updateThumb();
  });
})();
